var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { attrs: { id: "dashboard-sidebar" } }, [
      _c("ul", [
        _c("li", [
          _c("a", { attrs: { href: "/home" } }, [
            _vm._v("\n\t\t\t\tDashboard Home\n\t\t\t")
          ])
        ]),
        _vm._v(" "),
        _c("li", [
          _c("a", { attrs: { href: "/dropdowns/" } }, [
            _vm._v("\n\t\t\t\tManage Dropdowns\n\t\t\t")
          ])
        ]),
        _vm._v(" "),
        _c("li", [
          _c("a", { attrs: { href: "/banner/" } }, [
            _vm._v("\n\t\t\t\tManage Banner\n\t\t\t")
          ])
        ])
      ])
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2415a893", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2415a893","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/DashboardSidebar.vue
// module id = 409
// module chunks = 19